import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SuperAgent from 'superagent';
import createReactClass from 'create-react-class';
import emailIcon from './email_icon@2x.png';
import loadingSpinner from './loading-spinner-16.gif';

const VerifyEmail = createReactClass({
  propTypes: {
    shortGuid: PropTypes.string,
    emailAddress: PropTypes.string,
    csrf_token: PropTypes.string,
  },

  getInitialState() {
    return {
      processing: false,
    };
  },

  onSuccess() {
    this.setState({ processing: false });
  },

  onResendClick(e) {
    e.preventDefault();
    const self = this;

    this.setState({ processing: true });

    const resendAddress = '/signer/sendTemplateLinkEmail';

    SuperAgent.post(resendAddress)
      .type('form')
      .send({ email_address: this.props.emailAddress })
      .send({ guid: this.props.shortGuid })
      .send({ csrf_token: this.props.csrf_token })
      .end((err, res) => {
        if (!err) {
          const data = JSON.parse(res.text);
          self.onSuccess(data);
        }
      });
  },

  render() {
    const spinner = this.state.processing ? (
      <img
        className="spinner"
        style={{ position: 'absolute', left: '10%' }}
        src={loadingSpinner}
        width="16"
        height="16"
      />
    ) : null;

    return (
      <div className="m-verify-email row">
        <div className="m-verify-email--container">
          <div className="m-verify-email--text">
            <h4>
              <FormattedMessage
                id="0a6aa60eb15c30cc8d705f964fe81af72aaf4e4903f631e3e7e02ae471ee9718"
                defaultMessage="One last thing"
                description="Title on verify email modal"
              />
            </h4>
            <img src={emailIcon} />
            <div>
              <FormattedMessage
                id="9e0acb7e977fd70789467f6350b1c500e8bdfb3b6efb20a960c9361daeba44ae"
                defaultMessage="We just sent you an email."
                description="Text in verify email modal, informing user that an email has been sent"
              />
            </div>
            <div>
              <FormattedMessage
                id="31449266a593f2112786252160fee35ec05c44dea55d11a6dc894964c85fb89e"
                defaultMessage="Please open it and click 'Review Document'."
                description="Text in verify email modal, asking user to open email and click on link to review document"
              />
            </div>
          </div>
          <div className="m-verify-email--resend">
            {spinner}
            <FormattedMessage
              id="3de93a09305159513618ec487cb745fdd7a224f8f19655cc379d50b540d1ba9a"
              defaultMessage="Don't see it in your inbox? <btn>Click here to resend.</btn>"
              description="Text in verify email modal, asking user to resend email if they don't see it in their inbox"
              values={{
                btn: (chunks) => (
                  <a href="#" onClick={this.onResendClick}>
                    {chunks}
                  </a>
                ),
              }}
            />
          </div>
        </div>
        <span className="m-verify-email--legal">
          <FormattedMessage
            id="f2ec6b030fe54b1f5d139624f98b01b3b6e13d73f5028f2451d9cd336037a763"
            defaultMessage="Note: This step is required to comply with eSignature laws."
            description="Text in verify email modal, informing user that verifying email is required for eSignature compliance"
          />
        </span>
      </div>
    );
  },
});

export default VerifyEmail;
